export const TEXT_PLAIN = "text/plain";
export const TEXT_HTML = "text/html";
